import gql from 'graphql-tag'
import videoFields from './fragments/video-fields.gql'
import { PUBLISHED_POST_STATES } from '~/constants/content'

const buildMostRecentFeaturedVideoByCategoryQuery = ({
  statuses = PUBLISHED_POST_STATES,
}) => {
  return gql`
    query getMostRecentFeaturedVideoByCategory($category: String) {
      videos(
        first: 1
        where: {
          stati: [${statuses}]
          orderby: { field: DATE, order: DESC }
          showOnlyFeaturedPosts: true
          taxQuery: {
            relation: AND
            taxArray: [
              { terms: [$category], taxonomy: CATEGORY, operator: IN, field: SLUG }
            ]
          }
        }
      ) {
        nodes {
          ... videoFields
        }
      }
    }
    ${videoFields}
  `
}

export default buildMostRecentFeaturedVideoByCategoryQuery
